// @ts-check

import { SIDE_CART_RENDERED_EVENT, updateCartNote } from '@theme/lib-cart';
import { debounce } from '@theme/utilities';

/** @type {WeakMap<HTMLElement, AbortController>} */
const noteControllers = new WeakMap();

/**
 * @param {HTMLElement} root
 */
function initSideCartNote(root) {
  var existingController = noteControllers.get(root);
  existingController?.abort();

  var controller = new AbortController();
  noteControllers.set(root, controller);

  var noteField = root.querySelector('.side-cart__note-field');
  if (!(noteField instanceof HTMLTextAreaElement)) return;

  var saveNote = debounce(function (/** @type {string} */ note) {
    updateCartNote(note, { signal: controller.signal }).catch(function () {
      // Note saves are best-effort; cart line updates re-render from server state.
    });
  }, 300);

  noteField.addEventListener(
    'change',
    function (event) {
      var target = event.currentTarget;
      if (!(target instanceof HTMLTextAreaElement)) return;
      saveNote(target.value);
    },
    { signal: controller.signal }
  );

  noteField.addEventListener(
    'input',
    function (event) {
      var target = event.currentTarget;
      if (!(target instanceof HTMLTextAreaElement)) return;
      saveNote(target.value);
    },
    { signal: controller.signal }
  );
}

function initAllSideCartNotes() {
  document.querySelectorAll('.side-cart__note').forEach(function (root) {
    if (root instanceof HTMLElement) {
      initSideCartNote(root);
    }
  });
}

initAllSideCartNotes();
document.addEventListener(SIDE_CART_RENDERED_EVENT, initAllSideCartNotes);
